import { GetTermsConditions, UpdateTermsConditions, CreateTermsConditions } from "../../../connection/terms-conditions";
import { Action, AsyncAction } from "../../../types/actions";
import { TermsConditions, CreateTermsConditionsRequest } from "../../../types/working-model";

export const GET_TERMS_CONDITIONS = 'GET_TERMS_CONDITIONS';
export function getTermsConditions(terms_id: number): AsyncAction {
	return {
		type: GET_TERMS_CONDITIONS,
		promise: GetTermsConditions(terms_id),
	};
}

export const CREATE_TERMS_CONDITIONS = 'CREATE_TERMS_CONDITIONS';
export function createTermsConditions(newTerms: CreateTermsConditionsRequest, token: string): AsyncAction {
	return {
		type: CREATE_TERMS_CONDITIONS,
		promise: CreateTermsConditions(newTerms, token),
	};
}

export const UPDATE_TERMS_CONDITIONS = 'UPDATE_TERMS_CONDITIONS';
export function updateTermsConditions(updatedTerms: TermsConditions, token: string): AsyncAction {
	return {
		type: UPDATE_TERMS_CONDITIONS,
		promise: UpdateTermsConditions(updatedTerms, token),
	};
}

export const CLEAR_TERMS_CONDITIONS = 'CLEAR_TERMS_CONDITIONS';
export function clearTermsConditions(): Action {
	return {
		type: CLEAR_TERMS_CONDITIONS,
		payload: null,
	};
}
